"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentLabel = void 0;
Object.defineProperty(exports, "getComponentValidationRules", {
  enumerable: true,
  get: function get() {
    return _rules.getComponentValidationRules;
  }
});
Object.defineProperty(exports, "getFieldValidationRules", {
  enumerable: true,
  get: function get() {
    return _rules.getFieldValidationRules;
  }
});
exports.isRequiredField = exports.getInheritedFieldValidation = exports.getInheritedComponentValidation = void 0;
Object.defineProperty(exports, "validatePage", {
  enumerable: true,
  get: function get() {
    return _backend.validatePage;
  }
});
Object.defineProperty(exports, "validationRules", {
  enumerable: true,
  get: function get() {
    return _rules.validationRules;
  }
});

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var _rules = require("./rules");

var _backend = require("./backend");

var ComponentRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentRuleDefinition;
});

var FieldRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldRuleDefinition;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedComponentValidation;
});

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedFieldValidation;
});

var isRequiredField = function isRequiredField(rules) {
  return !!(rules && rules.some(function (rule) {
    return rule.required;
  }));
};

exports.isRequiredField = isRequiredField;

var getComponentLabel = function getComponentLabel(label) {
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var inheritedComponentRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var setRules = rules || [];
  var setInheritedComponentRules = inheritedComponentRules || [];
  var validationRules = [].concat((0, _toConsumableArray2["default"])(setRules), (0, _toConsumableArray2["default"])(setInheritedComponentRules));
  var isRequired = validationRules.some(function (rule) {
    return rule.phoneNumberRequired || rule.personCategoryRequired;
  });
  return !isRequired ? "".concat(label, " (optional)") : label;
};

exports.getComponentLabel = getComponentLabel;

var getInheritedComponentValidation = function getInheritedComponentValidation(componentKey, inheritedComponentValidation) {
  return inheritedComponentValidation ? inheritedComponentValidation.filter(function (item) {
    return componentKey === item.componentKey;
  }) : [];
};

exports.getInheritedComponentValidation = getInheritedComponentValidation;

var getInheritedFieldValidation = function getInheritedFieldValidation(fieldKey, inheritedFieldValidation) {
  return inheritedFieldValidation ? inheritedFieldValidation.filter(function (item) {
    return fieldKey === item.fieldKey;
  }) : [];
};

exports.getInheritedFieldValidation = getInheritedFieldValidation;